import { VDataTable } from 'vuetify/lib'

export default {
  name: 'Table',
  props: [
    'value',
    'headers',
    'items',
    'loading',
    'items-per-page',
    'page',
    'server-items-length',
    'item-key',
    'show-select',
    'search',
    'disable-sort',
    'no-data-text',
    'sort-by',
    'sort-desc'
  ],
  methods: {
    updateCurrentPage(page) {
      if ('update:request' in this.$listeners) {
        this.$emit(
          'update:request',
          this.calculateReqDataParam(page, this.itemsPerPage)
        )
      }

      this.$emit('update:page', page)
    },
    updateSortBy(field) {
      if ('update:sortBy' in this.$listeners) {
        this.$emit(
          'update:sortBy',
          field
        )
      }
    },
    updateSortDirection(desc) {
      if ('update:sortDirection' in this.$listeners) {
        this.$emit(
          'update:sortDirection',
          desc
        )
      }
    },
    updateItemsPerPage(itemsPerPage) {
      if (
        'update:request' in this.$listeners &&
        this.itemsPerPage !== itemsPerPage
      ) {
        this.$emit(
          'update:request',
          this.calculateReqDataParam(this.page, itemsPerPage)
        )
      }

      this.$emit('update:items-per-page', itemsPerPage)
    },
    calculateReqDataParam(page, itemsPerPage) {
      return {
        page: page,
        itemsPerPage: itemsPerPage,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage
      }
    },
    needToHidePagination() {
      const itemsPerPage =
        typeof this.itemsPerPage !== 'undefined' ? this.itemsPerPage : 10
      const total =
        typeof this.serverItemsLength !== 'undefined'
          ? this.serverItemsLength
          : this.items.length
      return total <= itemsPerPage
    }
  },
  render(h) {
    const itemsPerPageOptions = this.$props.itemsPerPage ? [this.$props.itemsPerPage, 5, 15, 30] : []
    return h(VDataTable, {
      props: {
        ...this.$props,
        hideDefaultFooter: this.needToHidePagination(),
        noDataText: this.$props.noDataText || 'Нет результатов',
        footerProps: {
          itemsPerPageOptions: itemsPerPageOptions.sort((a, b) => a - b),
          itemsPerPageText: 'Количество:',
          pageText: '{0}-{1} из {2}',
        }
      },
      scopedSlots: { ...this.$scopedSlots },
      on: {
        ...this.$listeners,
        'update:items-per-page': this.updateItemsPerPage,
        'update:page': this.updateCurrentPage,
        'update:sort-by': this.updateSortBy,
        'update:sort-desc': this.updateSortDirection,
      }
    })
  }
}
